//# sourceMappingURL=copy_button.mjs.map
/// <reference types="./copy_button.d.mts" />
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $clipboard from "../../../magellan/magellan/window/navigator/clipboard.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $attribute from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $events from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { px } from "../../../sketch/sketch/css/length.mjs";
import * as $h from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $function from "../../../tiamat/tiamat/function.mjs";
import * as $colors from "../../ds/colors.mjs";
import * as $button from "../../ds/components/button.mjs";
import * as $icons from "../../ds/icons.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";
import * as $global from "../../web/javascript/global.mjs";

export class Props extends $CustomType {
  constructor(content, actionable, inline) {
    super();
    this.content = content;
    this.actionable = actionable;
    this.inline = inline;
  }
}
export const Props$Props = (content, actionable, inline) =>
  new Props(content, actionable, inline);
export const Props$isProps = (value) => value instanceof Props;
export const Props$Props$content = (value) => value.content;
export const Props$Props$0 = (value) => value.content;
export const Props$Props$actionable = (value) => value.actionable;
export const Props$Props$1 = (value) => value.actionable;
export const Props$Props$inline = (value) => value.inline;
export const Props$Props$2 = (value) => value.inline;

function button(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.background($colors.light.grey_50),
      $css.border("1px solid " + $colors.light.grey_400),
      $css.border_radius(px(6)),
      $css.padding(px(4)),
      $css.color("inherit"),
    ]),
  );
  return $h.button(_pipe, attrs, children);
}

function inline_button(copied, attrs, children) {
  let _block;
  if (copied) {
    _block = [$colors.light.success_800, $colors.light.success_800];
  } else {
    _block = [$colors.light.grey_600, $colors.light.grey_800];
  }
  let $ = _block;
  let color = $[0];
  let hover_color = $[1];
  let _pipe = $css.class$(
    toList([
      $css.display("inline-flex"),
      $css.align_items("center"),
      $css.vertical_align("text-bottom"),
      $css.margin_left(px(4)),
      $css.padding(px(0)),
      $css.background($colors.light.transparent),
      $css.border("none"),
      $css.cursor("pointer"),
      $css.color(color),
      $css.hover(toList([$css.color(hover_color)])),
    ]),
  );
  return $h.button(_pipe, attrs, children);
}

function copy_icon(copied) {
  if (copied) {
    return $icons.check();
  } else {
    return $icons.copy();
  }
}

function use_copy_state(copied, set_copied, count) {
  return ((_capture) => {
    return $redraw.use_effect_(_capture, [copied, count]);
  })(
    () => {
      return $bool.guard(
        !copied,
        () => { return undefined; },
        () => {
          let timeout = $global.set_timeout(
            2000,
            () => { return set_copied(false); },
          );
          return () => { return $global.clear_timeout(timeout); };
        },
      );
    },
  );
}

export function copy_button() {
  return $redraw.component_(
    "CopyButton",
    (props) => {
      let $ = $redraw.use_state(false);
      let copied = $[0];
      let set_copied = $[1];
      let $1 = $redraw.use_state_(0);
      let count = $1[0];
      let set_count = $1[1];
      use_copy_state(copied, set_copied, count);
      let icon = copy_icon(copied);
      let on_click = $events.on_click(
        (_) => {
          return $function.tap(
            undefined,
            (_) => {
              return $promise.map(
                $clipboard.write_text(props.content),
                (_) => {
                  set_copied(true);
                  return set_count((count) => { return count + 1; });
                },
              );
            },
          );
        },
      );
      return $bool.guard(
        props.inline,
        inline_button(copied, toList([on_click]), toList([$icons.tiny(icon)])),
        () => {
          let $2 = props.actionable;
          if ($2) {
            return $button.inlay(
              toList([on_click]),
              toList([$icons.tiny(icon), $h.text("Copy")]),
            );
          } else {
            return button(toList([on_click]), toList([$icons.tiny(icon)]));
          }
        },
      );
    },
  );
}

export function content(content) {
  return new Props(content, false, false);
}

export function actionable(props, actionable) {
  return new Props(props.content, actionable, props.inline);
}

/**
 * Button icon flowing after the last word of the text.
 */
export function inline(props, inline) {
  return new Props(props.content, props.actionable, inline);
}
